// @ts-strict-ignore
import GA from 'react-ga4'
import { UaEventOptions } from 'react-ga4/types/ga4'
import { isProduction, isSandbox, isTest } from './environment'

const isEnabled = isSandbox || isProduction || isTest

const actions = {
  event: (event: string | UaEventOptions) => isEnabled && GA.event(event),
  set: (fields: unknown) => isEnabled && GA.set(fields),
  initialize: () => isEnabled && GA.initialize(process.env.ANALYTICS_ID),
  pageview: (path: string) => isEnabled && GA.send({ hitType: 'pageview', page: path }),
}

export const GoogleAnalytics = actions
